import { render, staticRenderFns } from "./WallTextBlockSettings.vue?vue&type=template&id=0d608cbd"
import script from "./WallTextBlockSettings.vue?vue&type=script&lang=js"
export * from "./WallTextBlockSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports